export const radioCard = {
  "radio-card": {
    cursor: "pointer",
    borderWidth: "1px",
    borderRadius: "md",
    boxShadow: "none",
    borderColor: "brand.500",
    transition: "0.2s ease all",
    color: "brand.500",
    px: 3,
    py: 1,
    _checked: {
      bg: "brand.500",
      color: "white",
      borderColor: "brand.500",
      _hover: {
        backgroundColor: "brand.500",
      }
    },
    _hover: {
      bg: "brand.50",
    },
    _focus: {
      boxShadow: "none",
    },
  },
  "radio-card-icon": {
    boxSize: 4,
    color: "brand.500",
    fill: "brand.500",
  },
  "radio-card-icon--active": {
    boxSize: 4,
    color: "white",
    fill: "white",
  }
};
